window.addEventListener("load", function(){
    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#77AF57",
                "text": "#ffffff"
            },
            "button": {
                "background": "transparent",
                "text": "#ffffff",
                "border": "#ffffff"
            }
        },
        "content": {
            "message": "En poursuivant votre navigation, vous acceptez le dépôt de cookies tiers destinés à vous proposer des vidéos, des boutons de partage, des remontées de contenus de plateformes sociales.",
            "dismiss": "<i class='fa fa-times' aria-hidden='true'></i>&nbsp;Fermer",
            "link": "En savoir plus",
            "href": "https://www.cnil.fr/fr/cookies-traceurs-que-dit-la-loi"
        },
        "position": "bottom-right"
    })
});